'use strict';

import Axios from 'axios';
import { parseResponse, handleError } from '@/_helpers/utils.js';
import * as Sentry from '@sentry/vue';

export default {
  fetchOne(token) {
    return new Promise((resolve, reject) => {
      return Axios.get(`/1.0/interviews/${token}`)
        .then(response => {
          resolve(parseResponse(response).data[0]);
        })
        .catch(err => reject(handleError(err)));
    });
  },

  fetchOneVideointerview(token) {
    return Axios.get(`/1.0/interviews/${token}/video_interviews`)
      .then(response => {
        let data = parseResponse(response).data[0];
        return data;
      })
      .catch(err => {
        return Promise.reject(handleError(err));
      });
  },

  endOneVideointerview(token) {
    return new Promise((resolve, reject) => {
      return Axios.put(`/1.0/interviews/${token}/video_interviews/end`)
        .then(response => {
          resolve(parseResponse(response).data[0]);
        })
        .catch(err => reject(handleError(err)));
    });
  },

  showOneVideointerviewQuestion(token, questionId) {
    return new Promise((resolve, reject) => {
      Axios.put(`/1.0/interviews/${token}/video_interview/questions/${questionId}/show`)
        .then(response => {
          resolve(parseResponse(response).data[0]);
        })
        .catch(err => reject(handleError(err)));
    });
  },

  showOneVideointerviewVideo(token, questionId) {
    return Axios.put(`/1.0/interviews/${token}/video_interview/questions/${questionId}/show-media`)
      .then(response => {
        return parseResponse(response).data[0];
      })
      .catch(err => Promise.reject(err));
  },

  skipOneVideointerviewQuestion(token, questionId) {
    return new Promise((resolve, reject) => {
      Axios.put(`/1.0/interviews/${token}/video_interview/questions/${questionId}/skip`)
        .then(response => {
          resolve(parseResponse(response).data[0]);
        })
        .catch(err => reject(handleError(err)));
    });
  },

  startOneVideointerviewQuestion(token, questionId) {
    return Axios.post(
      `/1.0/interviews/${token}/video_interview/questions/${questionId}/start-video`
    )
      .then(response => parseResponse(response).data[0])
      .catch(err => {
        return Promise.reject(handleError(err));
      });
  },

  saveOneVideointerviewQuestion(token, questionId, blob, onProgress) {
    let data = new FormData();
    data.append('video[source]', blob);
    // console.log('blob: ', blob);

    Sentry.captureException(onProgress);

    return Axios.post(`/1.0/interviews/${token}/video_interview/questions/${questionId}/save-video`, data, {
      onUploadProgress: event => {
        let completed = Math.ceil((event.loaded * 100) / event.total);

        onProgress && onProgress({ completed });
        Sentry.captureException(onProgress);
      }
    })
      .then(response => {
        Sentry.captureException(response);
        return parseResponse(response).data[0];
      })
      .catch(error => {
        Sentry.captureException(token || 'no token');
        Sentry.captureException(onProgress || 'no progress');
        Sentry.captureException(error.response.data);
        Sentry.captureException(error.response.status);
        Sentry.captureException(error.response.headers);
        Sentry.captureException(error.message || 'no message');
        // Sentry.captureException(err || 'no err');
        // Sentry.captureException(err || 'no err');

        return Promise.reject(handleError(error));
      });
  },

  saveOneVideointerviewTestVideo(token, blob, onProgress) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      data.append('video[source]', blob);
      Axios.post(`/1.0/interviews/${token}/video_interview/save-test_video`, data, {
        onUploadProgress: event => {
          let completed = Math.ceil((event.loaded * 100) / event.total);

          onProgress && onProgress({ completed });
        }
      })
        .then(response => {
          resolve(parseResponse(response).data[0]);
        })
        .catch(err => reject(handleError(err)));
    });
  },

  fetchOneTest(token) {
    return new Promise((resolve, reject) => {
      Axios.get(`/1.0/interviews/${token}/tests`)
        .then(response => resolve(parseResponse(response).data[0]))
        .catch(err => reject(handleError(err)));
    });
  },

  saveTestAnswers(token, questionId, models) {
    return new Promise((resolve, reject) => {
      Axios.put(`/1.0/interviews/${token}/tests/questions/${questionId}/answers`, {
        answers: models
      })
        .then(response => resolve(parseResponse(response).data[0]))
        .catch(err => reject(handleError(err)));
    });
  },

  endTest(token) {
    return new Promise((resolve, reject) => {
      // console.log('endTest');
      Axios.put(`/1.0/interviews/${token}/tests/end`)
        .then(response => resolve(parseResponse(response).data[0]))
        .catch(err => reject(handleError(err)));
    });
  }
};
